import { AnalyticsBrowser, SegmentEvent } from "@segment/analytics-next";
import { Platform } from "react-native";

import { isDev, isLocal } from "./config/env";

export let instantiatedSegment: AnalyticsBrowser | null;

const doWithDebug =
  <A extends any[], R>(fn: (...args: A) => Promise<R>, fnName: string) =>
  async (...args: A) => {
    if (isLocal || isDev) {
      console.log(`${fnName} called with`, ...args);
    }
    return fn(...args);
  };

const initSegment = () => {
  const writeKey = process.env.EXPO_PUBLIC_SEGMENT_WEB_WRITE_KEY;
  if (!writeKey) {
    console.warn("Segment write key not set, skipping initialization");
    return null;
  }

  const segment = AnalyticsBrowser.load(
    {
      writeKey,
    },
    // Used to better determine a user's actual device
    {
      highEntropyValuesClientHints: [
        "model",
        "platformVersion",
        "uaFullVersion",
      ],
    },
  );

  const ogSegmentTrack = segment.track;
  segment.track = (eventName: string | SegmentEvent, ...args) => {
    // Special case to propagate conversion event for Bing
    if (
      Platform.OS === "web" &&
      (eventName === "superclinical-__conversation-created" ||
        eventName === "superclinical-__clicked-start-a-visit")
    ) {
      (window as any).uetq = (window as any).uetq || [];
      (window as any).uetq.push("event", "null", {
        event_label: eventName,
      });
    }
    return ogSegmentTrack(eventName, ...args);
  };

  if (isLocal || isDev) {
    segment.track = doWithDebug(segment.track, "TRACK");
    segment.screen = doWithDebug(segment.screen, "SCREEN");
    segment.identify = doWithDebug(segment.identify, "IDENTIFY");
    segment.alias = doWithDebug(segment.alias, "ALIAS");
  }
  instantiatedSegment = segment;
  return segment;
};

export type Segment = AnalyticsBrowser;

export default initSegment;
